import { compose, composeU } from '@bem-react/core';
import {
    Button as ButtonPresenter,
    withSizeL,
    withSizeM,
    withThemeAction,
    withThemeNormal,
    withTypeLink
} from '@yandex-lego/components/Button/desktop';

export const Button = compose(
    composeU(withThemeNormal, withThemeAction),
    withTypeLink,
    composeU(withSizeM, withSizeL)
)(ButtonPresenter);
